export const getHighestStockQuantity = (
	variant: Queries.ProductVariantFragment,
) => {
	const allQuantities = variant.availability?.channels.map(
		(channel) => channel.availableQuantity ?? 0,
	) ?? [0];
	return Math.max(...allQuantities);
};

export const isOnStock = (variant: Queries.ProductVariantFragment) =>
	variant.availability?.channels.find((channel) => channel.isOnStock)
		?.isOnStock ?? false;
